<script>
import axios from 'axios'
import ModalBus from '@/eventBus'
import Eye from '@/components/icons/Eye'
import EyeSlash from '@/components/icons/EyeSlash'

export default {
  name: 'LoginForm',
  components: { EyeSlash, Eye },

  props: {
    type: {
      type: String,
      default: '',
    },

    redirectTo: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      login: {
        form: {
          email: '',
          password: '',
        },

        passwordShow: '',
        errors: {},
        sending: false,
        failed: false,
        failedMessage: '',
      },

      registration: {
        form: {
          lastname: '',
          firstname: '',
          email: '',
          password: '',
          password_confirmation: '',
        },

        passwordShow: '',
        errors: {},
        sending: false,
        success: false,
        successMessage: '',
      },

      passwordShow: '',
      showFormLogin: true,
      showFormRegistration: false,
    }
  },

  computed: {
    passwordIsShow() {
      return this.passwordShow
    },

    isPremiumType() {
      return 'premium' === this.type
    },

    isSupportType() {
      return 'support' === this.type
    },
  },

  methods: {
    handleSubmitLogin() {
      this.$recaptcha('login').then((token) => {
        this.login.form.token = token

        this.login.errors = {}
        this.login.sending = true
        this.login.failed = false

        axios
          .post('/login', this.login.form)
          .then((response) => {
            this.login.form = {}
            window.Laravel.user = response.data.user

            if (this.isPremiumType) {
              this.$root.openPremiumFormPopup()
            } else if (this.isSupportType) {
              document.location.reload()
            } else {
              if (this.redirectTo) {
                window.location.href = this.redirectTo
              } else {
                window.location.href = `/espace-membre`
              }
            }
          })
          .catch((error) => {
            this.login.failed = true
            this.login.sending = false
            if (error.response.status === 401) {
              this.login.failedMessage = error.response.data.error || {}
            } else if (error.response.status === 422) {
              this.login.errors = error.response.data.errors || {}
            }
          })
      })
    },

    handleSubmitRegistration() {
      this.$recaptcha('register').then((token) => {
        this.registration.form.token = token
        this.registration.errors = {}
        this.registration.sending = true
        axios
          .post('/registration', this.registration.form)
          .then((response) => {
            this.registration.form = {}
            this.registration.success = true
            this.registration.successMessage = response.data.message
            window.Laravel.user = response.data.user

            setTimeout(() => {
              window.location.href = `/espace-membre`
            }, 1000)
          })
          .catch((error) => {
            this.registration.sending = false
            if (error.response.status === 422) {
              this.registration.errors = error.response.data.errors || {}
            }
          })
      })
    },

    toggleLogin() {
      this.showFormRegistration = false
      this.showFormLogin = true
    },

    toggleRegistration() {
      this.showFormLogin = false
      this.showFormRegistration = true
    },

    togglePasswordType() {
      this.passwordShow = !this.passwordShow
    },

    closeModal: function () {
      this.toggleLogin()
      ModalBus.emit('close')
      this.$emit('close')
    },
  },
}
</script>

<template>
  <div class="h-auto w-4/5 overflow-y-auto bg-white md:rounded-2xl lg:w-1/2">
    <div class="item-center flex justify-between border-b-2 border-light/25 p-5">
      <div class="flex items-center lg:text-secondary">
        <span
          v-if="showFormLogin"
          class="font-poppins text-xl font-medium">
          {{ $t('auth.login.title') }}
        </span>
        <span
          v-if="showFormRegistration"
          class="font-poppins text-xl font-medium">
          {{ $t('auth.registration.title') }}
        </span>
      </div>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closeModal">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>

    <form
      v-if="showFormLogin"
      method="POST"
      @submit.prevent="handleSubmitLogin">
      <div class="p-5">
        <div class="w-full">
          <div
            v-if="login.failed"
            class="relative rounded-lg bg-red-100 px-3 py-3 text-sm text-red-700">
            {{ login.failedMessage }}
          </div>

          <label class="form__label">
            <span>{{ $t('auth.login.form.email.label') }}</span>
            <input
              v-model="login.form.email"
              :placeholder="$t('auth.login.form.email.placeholder')"
              autocomplete="email"
              class="form__input bg-white"
              name="email"
              type="email" />
          </label>
          <label class="form__label">
            <span>{{ $t('auth.login.form.password.label') }}</span>
            <div class="relative mt-2 w-full">
              <input
                v-model="login.form.password"
                :placeholder="$t('auth.login.form.password.placeholder')"
                :type="passwordShow ? 'text' : 'password'"
                autocomplete="current-password"
                class="form__input mt-0 w-full bg-white"
                name="email" />
              <button
                class="absolute right-4 top-1/2 -translate-y-1/2 focus:cursor-pointer focus:outline-none"
                type="button"
                @click="togglePasswordType">
                <Eye
                  v-if="passwordShow"
                  key="eye-1"
                  class="h-auto w-6"></Eye>
                <EyeSlash
                  v-else
                  key="eye-slash-1"
                  class="h-auto w-6"></EyeSlash>
              </button>
            </div>
          </label>
          <label class="form__label">
            <a
              class="cursor-pointer text-secondary"
              href="/mot-de-passe-perdu">
              {{ $t('auth.login.reset') }}
            </a>
          </label>

          <label class="form__label">
            <span
              class="cursor-pointer text-secondary"
              @click="toggleRegistration">
              {{ $t('auth.login.signup') }}
            </span>
          </label>
          <div>
            <button
              :disabled="login.sending"
              class="btn mt-8 w-full"
              type="submit">
              {{ $t('auth.login.form.button.label') }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <form
      v-if="showFormRegistration"
      method="POST"
      @submit.prevent="handleSubmitRegistration">
      <div class="p-5">
        <div class="w-full">
          <div
            v-if="registration.success"
            class="relative rounded-lg bg-primary px-3 py-3 text-sm text-white">
            {{ registration.successMessage }}
          </div>

          <div class="grid grid-cols-2 gap-6">
            <label class="form__label">
              <span>{{ $t('auth.registration.form.firstname.label') }}</span>
              <input
                v-model="registration.form.firstname"
                :placeholder="$t('auth.registration.form.firstname.placeholder')"
                class="form__input bg-white"
                type="text" />
            </label>
            <label class="form__label">
              <span>{{ $t('auth.registration.form.lastname.label') }}</span>
              <input
                v-model="registration.form.lastname"
                :placeholder="$t('auth.registration.form.lastname.placeholder')"
                class="form__input bg-white"
                type="text" />
            </label>
          </div>

          <label class="form__label">
            <span>{{ $t('auth.registration.form.email.label') }}</span>
            <input
              v-model="registration.form.email"
              :placeholder="$t('auth.registration.form.email.placeholder')"
              autocomplete="email"
              class="form__input bg-white"
              type="email" />
            <span
              v-if="registration.errors && registration.errors.email"
              class="text-xs text-red-500"
              >{{ registration.errors.email[0] }}</span
            >
          </label>
          <label class="form__label">
            <span>{{ $t('auth.registration.form.password.label') }}</span>
            <div class="relative mt-2 w-full">
              <input
                v-model="registration.form.password"
                :placeholder="$t('auth.registration.form.password.placeholder')"
                :type="passwordShow ? 'text' : 'password'"
                autocomplete="current-password"
                class="form__input mt-0 w-full bg-white" />
              <button
                class="absolute right-4 top-1/2 -translate-y-1/2 focus:cursor-pointer focus:outline-none"
                type="button"
                @click="togglePasswordType">
                <Eye
                  v-if="passwordShow"
                  class="h-auto w-6"></Eye>
                <EyeSlash
                  v-else
                  key="eye-slash-2"
                  class="h-auto w-6"></EyeSlash>
              </button>
            </div>
            <span
              v-if="registration.errors && registration.errors.password"
              class="text-xs text-red-500"
              >{{ registration.errors.password[0] }}</span
            >
          </label>
          <label class="form__label">
            <span>{{ $t('auth.registration.form.password_confirm.label') }}</span>
            <div class="relative mt-2 w-full">
              <input
                v-model="registration.form.password_confirmation"
                :placeholder="$t('auth.registration.form.password_confirm.placeholder')"
                :type="passwordShow ? 'text' : 'password'"
                autocomplete="current-password"
                class="form__input mt-0 w-full bg-white" />
              <button
                class="absolute right-4 top-1/2 -translate-y-1/2 focus:cursor-pointer focus:outline-none"
                type="button"
                @click="togglePasswordType">
                <Eye
                  v-if="passwordShow"
                  class="h-auto w-6"></Eye>
                <EyeSlash
                  v-else
                  key="eye-slash-3"
                  class="h-auto w-6"></EyeSlash>
              </button>
            </div>
            <span
              v-if="registration.errors && registration.errors.password_confirmation"
              class="text-xs text-red-500"
              >{{ registration.errors.password_confirmation[0] }}</span
            >
          </label>

          <label class="form__label">
            <span
              class="cursor-pointer text-secondary"
              @click="toggleLogin">
              {{ $t('auth.registration.signin') }}
            </span>
          </label>

          <div>
            <button
              :disabled="registration.sending"
              class="btn mt-8 w-full"
              type="submit">
              {{ $t('auth.registration.form.button.label') }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
